<section class="rcx-table" >
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex justify-content-between align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-bank m-0">
                                    <i class='ri-file-edit-line me-1 text-primary'></i>Resignations
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-3 me-auto">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Search separations by AppliedOn date." placement="top"
                                        container="body">
                                        <i class="bx bx-search-alt"></i>
                                    </span>
                                    <input type="text" class="form-control border-start-0" id="search"
                                        placeholder="Search..." autocomplete="off" [(ngModel)]="searchKeyword">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-auto">
                                <button type="button" class="btn btn-secondary" (click)="upsertSeparation(false)"
                                [disabled]="isApplyCheck === false">
                                    <i class="bx bx-plus"></i> Apply Resignation
                                </button>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="300">Applied On</th>
                                    <th scope="col" width="300">Last Working Day</th>
                                    <th scope="col" width="300">Reason</th>
                                    <th scope="col" width="150">Status</th>
                                    <th scope="col" width="150" class="text-center">Approved On</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let separation of separations | search : 'appliedOn' : searchKeyword; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{separation.appliedOn | date:'MMM dd, yyyy'}}</td>
                                    <td>{{separation.lastWorkingDay | date:'MMM dd, yyyy'}}</td>
                                    <td>{{separation.reason}}</td>
                                    <td>{{separation.status}}</td>
                                    <td class="actions">
                                        <button type="button" class="btn view-btn btn-sm btn-outline-info"
                                            (click)="upsertSeparation(true,separation)">
                                            <ng-container *ngIf="inProgress?.value!='true'">
                                                <i class="bx"
                                                    [ngClass]="appraisal?.active ? 'bx-check' : 'bx-show'"></i>
                                                View
                                            </ng-container>
                                        </button>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="7">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="separations && separations.length < 1; else noSearchResults">
                                            <td colspan="7">No resignations were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="7"
                                                *ngIf="searchKeyword && (separations | search : 'appliedOn' : searchKeyword).length == 0">
                                                No resignations were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>